import React, { Children } from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.5
      }
    }
  };
  const titleText = 'JIBEK JOLU GROUP';
  const titleVariants = {
    hidden: {
      opacity: 0,
      y: 50
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: [0.2, 0.65, 0.3, 0.9]
      }
    }
  };
  const lineVariants = {
    hidden: {
      scaleX: 0,
      opacity: 0
    },
    visible: {
      scaleX: 1,
      opacity: 1,
      transition: {
        duration: 1.5,
        ease: 'easeInOut',
        delay: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 1,
        ease: [0.16, 1, 0.3, 1]
      }
    }
  };
  const logoVariants = {
    hidden: {
      opacity: 0,
      scale: 0.8
    },
    visible: {
      opacity: 1,
      scale: 1,
      transition: {
        duration: 1.2,
        ease: [0.16, 1, 0.3, 1]
      }
    }
  };
  return <section className="relative min-h-screen flex items-center justify-center bg-brand-dark overflow-hidden pt-20" data-id="element-124">
      {/* Background Image */}
      <div className="absolute inset-0 z-0" data-id="element-125">
        <img src="https://cdn.magicpatterns.com/uploads/3sJXsc4yhJY9QKzHzC7fxn/IMG_6261.webp" alt="" className="w-full h-full object-cover object-center opacity-35" data-id="element-126" />
        <div className="absolute inset-0 bg-brand-dark/70" data-id="element-127"></div>
      </div>

      {/* Noise Overlay */}
      <div className="absolute inset-0 bg-noise pointer-events-none z-20" data-id="element-128"></div>

      {/* Subtle background gradient */}
      <div className="absolute inset-0 opacity-30 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-brand-red/20 via-transparent to-transparent z-[1]" data-id="element-129"></div>

      <motion.div className="relative z-10 flex flex-col items-center text-center px-6 max-w-4xl mx-auto" variants={containerVariants} initial="hidden" animate="visible" data-id="element-130">
        <motion.div variants={logoVariants} className="mb-12" data-id="element-131">
          <img src="https://cdn.magicpatterns.com/uploads/cPkLq24FKKtQpiCoiqri7q/Ресурс_1.svg" alt="Jibek Jolu Group Logo" className="w-32 md:w-48 h-auto filter invert opacity-90 drop-shadow-2xl" data-id="element-132" />
        </motion.div>

        <div className="flex overflow-hidden mb-6" data-id="element-133">
          {titleText.split('').map((char, index) => <motion.span key={index} variants={titleVariants} className="text-4xl md:text-6xl lg:text-7xl font-serif text-white tracking-wider" style={{
          display: char === ' ' ? 'inline' : 'inline-block'
        }} data-id="element-134">
              {char === ' ' ? '\u00A0' : char}
            </motion.span>)}
        </div>

        <motion.div variants={itemVariants} className="flex items-center gap-6 mb-12" data-id="element-135">
          <div className="h-px w-16 bg-brand-gold/50" data-id="element-136"></div>
          <span className="text-brand-gold tracking-[0.4em] text-sm font-medium uppercase" data-id="element-137">
            Since 2009
          </span>
          <div className="h-px w-16 bg-brand-gold/50" data-id="element-138"></div>
        </motion.div>

        <motion.p variants={itemVariants} className="text-lg md:text-2xl text-white/80 font-light max-w-3xl leading-relaxed drop-shadow-md" data-id="element-139">
          From a small family restaurant to a group of unique dining experiences
          — united by honest food, warm hospitality, and community.
        </motion.p>
      </motion.div>

      <motion.div className="absolute bottom-0 left-1/2 -translate-x-1/2 flex flex-col items-center z-10" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 2.5,
      duration: 1
    }} data-id="element-140">
        <span className="text-[10px] uppercase tracking-[0.3em] text-white/50 mb-4" data-id="element-141">
          Scroll
        </span>
        <div className="w-px h-24 bg-white/10 relative overflow-hidden" data-id="element-142">
          <motion.div className="absolute top-0 left-0 w-full h-1/3 bg-brand-gold" animate={{
          top: ['-33%', '100%']
        }} transition={{
          repeat: Infinity,
          duration: 1.5,
          ease: 'linear'
        }} data-id="element-143" />
        </div>
      </motion.div>
    </section>;
}